// import { fetchFriendTransferData } from "../../../../redux/actions/friend";
// import { fetchIntroductionData } from "../../../../redux/actions/introduction";
// import { fetchMemberTransferData } from "../../../../redux/actions/member";
import * as Sentry from "@sentry/react";
import Friends from "../../../../services/api/friend";
import Member from "../../../../services/api/member";
import ViewIntroduction from "../../../../services/api/viewIntroduction";

// const FORWARD_FIELDS = ["zoneId", "regionId", "chapterId", "districtId"];

export const MODAL_TYPES = {
  ACCEPT: "ACCEPT",
  FORWARD: "FORWARD",
  REJECT: "REJECT",
};

const getApiName = (modalType) => {
  if (modalType === MODAL_TYPES.ACCEPT) {
    return ["acceptMember", "acceptFriend", ""]; // don't alter order
  }
  if (modalType === MODAL_TYPES.FORWARD) {
    return ["forwardMember", "forwardFriend", "forwardIntroduction"]; // don't alter order
  }
  return ["rejectMember", "rejectFriend", "rejectIntroduction"]; // don't alter order
};

export const getApiMethodAndName = ({
  cameFromMemberTransfer,
  cameFromFriendTransfer,
  modalType,
}) => {
  if (cameFromMemberTransfer) {
    return {
      api: Member,
      apiName: getApiName(modalType)[0],
    };
  }
  if (cameFromFriendTransfer) {
    return {
      api: Friends,
      apiName: getApiName(modalType)[1],
    };
  }
  return {
    api: ViewIntroduction,
    apiName: getApiName(modalType)[2],
  };
};

export const getApiPayload = ({
  cameFromMemberTransfer,
  cameFromFriendTransfer,
  body,
  selectedRow,
}) => {
  if (cameFromMemberTransfer) {
    return {
      data: body,
      memberId: selectedRow.memberId,
      transferRequestId: selectedRow.transferId,
    };
  }
  if (cameFromFriendTransfer) {
    return {
      data: body,
      friendId: selectedRow.friendId,
      transferRequestId: selectedRow.transferId,
    };
  }
  return {
    data: body,
    id: selectedRow.introductionId,
  };
};

export const getApi = ({
  cameFromMemberTransfer,
  cameFromFriendTransfer,
  selectedRow,
  modalType,
  body,
}) => {
  const { api, apiName } = getApiMethodAndName({
    cameFromMemberTransfer,
    cameFromFriendTransfer,
    modalType,
  });
  const apiPayload = getApiPayload({
    cameFromMemberTransfer,
    cameFromFriendTransfer,
    selectedRow,
    body,
  });
  return { api, apiName, apiPayload };
};

export const getRemarkApiMethodAndName = ({
  cameFromMemberTransfer,
  cameFromFriendTransfer,
  selectedRow,
  body,
}) => {
  let result = {
    api: ViewIntroduction,
    apiName: "addRemark",
  };
  if (cameFromMemberTransfer) {
    result = {
      api: Member,
      apiName: "addRemarkForMemberTransfer",
    };
  }
  if (cameFromFriendTransfer) {
    result = {
      api: Friends,
      apiName: "addRemarkForFriendTransfer",
    };
  }
  const apiPayload = getApiPayload({
    cameFromMemberTransfer,
    cameFromFriendTransfer,
    selectedRow,
    body,
  });

  return { ...result, apiPayload };
};

// const getField = (field) => field.split("Id")[0];

export const formValidation = (formData, remark, isAccept = false) => {
  if (!formData.addressLine1) {
    return "Address cannot empty!";
  }
  if (String(formData.addressLine1).length < 5) {
    return "Please enter valid Address";
  }
  if (!formData.mobileNumber) {
    return "Mobile number cannot be empty!";
  }
  if (!remark || !remark.length) {
    return "Please add remark";
  }
  if (isAccept) {
    if (!formData.blockId) {
      return "Block cannot be empty!";
    }
    // } else {
    //   const invalidField = FORWARD_FIELDS.find((field) => !formData[field]);
    //   if (invalidField) {
    //     return `${getField(invalidField)} cannot be empty!`;
    //   }
  }
  return "";
};

export const getSeletedRowId = (selectedRow) =>
  selectedRow?.transferId ||
  selectedRow?.transferRequestId ||
  selectedRow?.introductionId;

export const fetchRemarks = async ({
  cameFromFriendTransfer,
  cameFromMemberTransfer,
  setRemarks,
  id,
}) => {
  let result = null;
  try {
    if (cameFromFriendTransfer) {
      result = await Friends.getFriendRemarks({
        transferId: id,
      });
    } else if (cameFromMemberTransfer) {
      result = await Member.getMemberRemarks({
        transferRequestId: id,
      });
    } else {
      result = await ViewIntroduction.getIntroductionRemarksData({
        id,
      });
    }
    setRemarks(result.data);
  } catch (error) {
    Sentry.captureException(error);
  }
};

// export const refreshTransferList = ({
//   cameFromMemberTransfer,
//   cameFromFriendTransfer,
// }) => {
//   if (cameFromMemberTransfer) {
//     fetchMemberTransferData("assignedToMe");
//   }
//   if (cameFromFriendTransfer) {
//     fetchFriendTransferData();
//   } else {
//     fetchIntroductionData("assignedToMe");
//   }
// };
